/** @jsx jsx */
import {jsx, css} from '@emotion/react'
// eslint-disable-next-line no-unused-vars
import React, {useEffect, useState} from 'react'
import Section1 from './Section1'
import Section2 from './Section2'
import Section3 from './Section3'
import Footer from './Footer'
import {EVENTS, logDplWithAppParams} from '../../../util/dpl'
import {getCountry} from '../../../util/getCountry'
import {logSgc} from '../../../util/extensionMetadata'
import VanishHero from './VanishHero'
import {colors} from '../../../constants'
import VanishFavicons from './VanishFavicons'
import {getUrlParameterByName} from '../../../util/url'
import {iOSAppStoreLink} from '../../../util/vanishAppDownloadLinks'
import TopBar from './TopBar'

const VanishV1 = ({os, browser, experimentId, languageCode = `en`}) => {
    const isMobile = new Set(['ios', 'android']).has(os)

    const [showPage, setShowPage] = useState(false)
    const [showTopBar, setShowTopBar] = useState(false)

    useEffect(() => {
        if (!experimentId) return
        logSgc()
        const shouldRedirect = Boolean(getUrlParameterByName('redirect')) && isMobile
        if (shouldRedirect) {
            logDplWithAppParams(EVENTS.StartpageAppRedirect, {
                os,
                country: getCountry(),
                experiment: experimentId,
            }).then(() => {
                if (os === 'ios') {
                    window.location.href = iOSAppStoreLink
                }
                // setTimeout delays showing the page content so user just sees white screen before being
                // redirected to the app (in an attempt to make the transition smoother)
                // still, we wanna show the page eventually if the redirect doesnt happen, so this here is the fallback
                setTimeout(() => {
                    setShowPage(true)
                }, 2000)
            })
        } else {
            setShowPage(true)
            logDplWithAppParams(EVENTS.StartpageAppPageLoad, {
                os,
                country: getCountry(),
                experiment: experimentId,
            })
        }
    }, [experimentId, isMobile, os])

    return (
        <>
            <VanishFavicons languageCode={languageCode} />
            <TopBar
                languageCode={languageCode}
                isMobileDevice={isMobile}
                showTopBar={showTopBar}
                os={os}
                experiment={experimentId}
            />
            <div
                className="vanish-v1"
                css={css`
                    width: 100%;
                    overflow: hidden;
                    visibility: ${showPage ? 'visible' : 'hidden'};
                    p, span {
                        color ${colors.black} !important;
                    }
                `}
            >
                <VanishHero
                    os={os}
                    browser={browser}
                    experimentId={experimentId}
                    languageCode={languageCode}
                    isMobileDevice={isMobile}
                    setShowTopBar={setShowTopBar}
                />
                <div>
                    <Section1 experimentId={experimentId} os={os} browser={browser} languageCode={languageCode} />
                    <Section2 experimentId={experimentId} os={os} browser={browser} languageCode={languageCode} />
                    <Section3
                        experimentId={experimentId}
                        os={os}
                        browser={browser}
                        languageCode={languageCode}
                        isMobileDevice={isMobile}
                    />
                    <Footer experimentId={experimentId} os={os} browser={browser} languageCode={languageCode} />
                </div>
            </div>
        </>
    )
}

export default VanishV1
